import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';
import { BaseValidator } from '@tcm-modules/tcm-core.module';

@Directive({
    selector: '[greaterThanOrEqualTo]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: GreaterThanOrEqualToValidator, multi: true }
    ],
    standalone: false
})
export class GreaterThanOrEqualToValidator extends BaseValidator implements OnChanges {

  @Input('greaterThanOrEqualTo')
  otherValue: string;

  @Input()
  comparisonType: string;

  @Input()
  fieldName: string;

  @Input()
  errorMessage: string;

  constructor() {
    super('greaterThanOrEqualTo');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.otherValue && changes.otherValue.isFirstChange()) {
      return;
    }

    this._onChange();
  }

  protected getValidationResult(control: any) {
    if (control.value == null || this.otherValue == null) {
      return null;
    }

    let firstValue: any = control.value;
    let secondValue: any = this.otherValue;
    if (this.comparisonType === "Date") {
      firstValue = new Date(control.value);
      secondValue = new Date(this.otherValue);
    }

    if (firstValue >= secondValue)
      return null;

    let validationResult = { 'greaterThanOrEqualTo': { fieldName: this.fieldName, error: null } };

    if (this.errorMessage) {
      validationResult.greaterThanOrEqualTo.error = this.errorMessage;
    }

    return validationResult;
  }
}
